import { trigger, transition, style, animate, query, stagger } from '@angular/animations';

export const staggerEntrance = trigger('staggerEntrance', [
  transition(':enter', [
    query(':enter', [
      style({ opacity: 0, transform: 'translateX(20px)' }),
      stagger(100, [
        animate(
          '600ms cubic-bezier(0.22, 1, 0.36, 1)',
          style({ opacity: 1, transform: 'translateX(0)' })
        ),
      ]),
    ], { optional: true }),
  ]),
]);

export const staggerSlideIn = trigger('staggerSlideIn', [
  transition(':enter', [
    query(':enter', [
      style({ opacity: 0, transform: 'translateX(20px)' }),
      stagger(80, [
        animate(
          '500ms cubic-bezier(0.22, 1, 0.36, 1)',
          style({ opacity: 1, transform: 'translateX(0)' })
        ),
      ]),
    ], { optional: true }),
  ]),
]);
